import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, UserRound, HeartHandshake, ClipboardList, Home, PartyPopper } from "lucide-react";
import { VideoPlayer } from "@/components/MediaSlot";
import { IconGrid } from "@/components/IconArt";
import { useLang } from "@/i18n";
import { track } from "@/lib/api";
import { useSettings } from "@/lib/settings";

const CORE = [UserRound, HeartHandshake, ClipboardList, Home, PartyPopper];

export default function WhyChela() {
  const { t, lang } = useLang();
  const s = useSettings();
  const navigate = useNavigate();
  const main = s.media?.why_choose_us_video || {};
  const caption = `Ghar ho, parivar ho ya koi zaroori kaam, ek verified local CHELA, ghante ke hisaab se. ${s.currency}${s.base_hourly_price} per hour. Bhopal mein ab live.`;

  return (
    <section id="why" className="chela-section bg-[#F3EFEA]">
      <div className="chela-container">
        <span className="eyebrow">{t("why_eyebrow")}</span>
        <h2 className="mt-4 font-display font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-[#121316]">{t("why_h2")}</h2>
        <div className="mt-12 grid lg:grid-cols-12 gap-8">
          <div className="lg:col-span-5">
            <div className="rounded-3xl overflow-hidden border border-[#E5E0D8] bg-[#121316] aspect-[9/16] max-h-[600px] mx-auto">
              {(main.url || "").trim()
                ? <VideoPlayer slot={main} poster={main.poster} testid="why-video" alt="CHELA" />
                : <IconGrid kinds={["personal", "family", "errands", "homehelp"]} lang={lang} className="h-full" />}
            </div>
            <p data-testid="why-video-caption" className="mt-4 font-semibold text-[#121316] leading-relaxed">{caption}</p>
          </div>
          <div className="lg:col-span-7 space-y-4">
            {CORE.map((Icon, i) => (
              <div key={i} data-testid={`why-card-${i + 1}`} className="chela-card rounded-3xl p-6 flex items-start gap-4" style={{ transform: "none" }}>
                <span className="h-12 w-12 rounded-2xl bg-[#FFF1EC] flex items-center justify-center shrink-0"><Icon size={22} className="text-[#E05624]" /></span>
                <div>
                  <h3 className="font-display font-bold text-xl text-[#121316]">{t(`why_${i + 1}_t`)}</h3>
                  <p className="mt-1.5 text-[#5A5D65] leading-relaxed">{t(`why_${i + 1}_d`)}</p>
                </div>
              </div>
            ))}
            <button data-testid="why-book-btn" onClick={() => { track("book_click", { source: "why" }); navigate("/book"); }} className="inline-flex items-center gap-2 h-14 px-8 rounded-full btn-saffron text-base font-bold">
              {t("book")} <ArrowRight size={18} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
